import { render } from "./SupplierDetailDocumentsTab.vue?vue&type=template&id=44c08146&scoped=true"
import script from "./SupplierDetailDocumentsTab.vue?vue&type=script&lang=js"
export * from "./SupplierDetailDocumentsTab.vue?vue&type=script&lang=js"

import "./SupplierDetailDocumentsTab.vue?vue&type=style&index=0&id=44c08146&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c08146"]])

export default __exports__